import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchStops } from '../services/api';
import FavoriteStopsList from './FavoriteStopsList';
import StopsSearch from './StopsSearch';
import StopsSort from './StopsSort';
import StopsPagination from './StopsPagination';
import StopsGrid from './StopsGrid';
import StopsStatus from './StopsStatus';
import useUserLocation from '../hooks/useUserLocation';
import useFavorites from '../hooks/useFavorites';
import useStops from '../hooks/useStops';

import { calculateDistance } from '../utils/geo';



function StopsList() {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const stopsPerPage = 24; // Liczba przystanków na stronę

  const {
    userLocation,
    isLoadingLocation,
    locationError,
    getUserLocation
  } = useUserLocation();


  const [sortOrder, setSortOrder] = useState('distance');

  useEffect(() => {
    if (sortOrder === 'distance' && !userLocation) {
      getUserLocation();
    }
  }, [sortOrder, userLocation]);

  const {
    stops,
    filteredStops,
    sortedStops,
    loading,
    error
  } = useStops(searchTerm, sortOrder, userLocation, calculateDistance);

  const {
    favoriteStops,
    favoriteStopsData,
    toggleFavorite,
    updateFavoritesOrder
  } = useFavorites(stops);

  // Oblicz, które przystanki powinny być wyświetlone na aktualnej stronie
  const indexOfLastStop = currentPage * stopsPerPage;
  const indexOfFirstStop = indexOfLastStop - stopsPerPage;
  const currentStops = sortedStops.slice(indexOfFirstStop, indexOfLastStop);
  const totalPages = Math.ceil(filteredStops.length / stopsPerPage);

  if (loading || error) {
    return <StopsStatus loading={loading} error={error} />;
  }


  return (
    <div className="stops-container">
      <h1>
        <img src={process.env.PUBLIC_URL + '/logo.jpg'} alt="" className="stops-header-logo" />
        3City Live
      </h1>

      {/* Sekcja ulubionych przystanków */}
      <FavoriteStopsList
        favoriteStopsData={favoriteStopsData}
        favoriteStops={favoriteStops}
        userLocation={userLocation}
        sortOrder={sortOrder}
        toggleFavorite={toggleFavorite}
        calculateDistance={calculateDistance}
        onReorder={updateFavoritesOrder}
      />

      <h2>Wszystkie przystanki</h2>

      {/* Sekcja wyszukiwania i sortowania - bezpośrednio przed listą wszystkich przystanków */}
      <StopsSearch
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />

      {/* Sekcja sortowania */}
      <StopsSort
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
      />

      {/* Reszta kodu z paginacją/wirtualizacją */}
      <StopsGrid
        currentStops={currentStops}
        favoriteStops={favoriteStops}
        toggleFavorite={toggleFavorite}
        userLocation={userLocation}
        sortOrder={sortOrder}
        calculateDistance={calculateDistance}
      />

      <StopsPagination
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}

export default StopsList;